import { ServiceEndpoints } from "../constants";
import { Organization } from "types/organization";
import { axios } from "./apiConfig";

// Fetch all organizations
export const getOrganizations = async () => {
  return axios
    .get(ServiceEndpoints.ORGANIZATIONS)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// Create a new organization
export const createOrganization = async (data: Organization) => {
  return axios
    .post(ServiceEndpoints.ORGANIZATIONS, data)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// Update an existing organization
export const updateOrganization = async (
  id: string | number,
  data: Organization["org"]
) => {
  const { ...organizationData } = data;

  return axios
    .put(`${ServiceEndpoints.ORGANIZATION}/${id}`, organizationData)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// Get an organization by its ID
export const getOrganizationById = async (id: string) => {
  return axios
    .get(`${ServiceEndpoints.ORGANIZATION}/${id}`)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// Delete an organization
export const deleteOrganization = async (id: string) => {
  return axios
    .delete(`${ServiceEndpoints.ORGANIZATIONS}/${id}`)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};
